//我的证书
import request from '../utils/request';
// //获取证书列表
// export function toMyCertList(data) {
//   return request({
//     url: '/wap/learning/toMyCertList.do',
//     method: 'post',
//     data
//   })
// }
//查看证书
export function getCertDetail(data) {
  return request({
    url: '/wap/learning/getCertDetail.html',
    method: 'post',
    data
  })
}
//获取证书申领
export function toMyCertList(data) {
  return request({
    url: '/learning/toMyCertList.do',
    method: 'post',
    data
  });
}
//获取证书申领列表
export function getCreditApplyList(data) {
  return request({
    url: '/wap/learning/getCreditApplyList',
    method: 'post',
    data
  });
}
//获取合并完证书申领列表
export function getMergeCertList(data) {
  return request({
    url: '/wap/learning/getMergeCertList',
    method: 'post',
    data
  });
}
//合并学时
export function mergeCredit(data) {
  return request({
    url: '/wap/learning/mergeCredit',
    method: 'post',
    data
  });
}



